<template>
  <div v-if="values.length" :columns="4" :style="style" class="col-md-12 overflow-auto">
    <h6 class="text-center mb-2 mt-4" style="text-align: center !important">{{ tableName }}</h6>

    <b-row class="mt-2 mb-2">
      <b-col :cols="6">
        <!-- <list-control label="Rows per Page">
          <b-input
            block
            v-model="rowsPerPage"
            type="number"/>
        </list-control> -->

          <b-input-group
            label="Filter"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
            :width="enableSort ? '180px' : '320px'">
            <b-form-input v-model="search" placeholder="Type to search table"/>
            <b-input-group-append>
              <b-button :disabled="!search" @click="search = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
      </b-col>
      <b-col :cols="4"></b-col>
      <b-col :cols="2" class="text-right">
        <!-- <list-control :label="`${columns.length} columns`" width="100%">
          <b-dropdown text="Active columns">
            <div
              v-for="col in fields"
              :key="col.key"
              class="dropdown-item text-body">
              <b-form-checkbox
                v-model="columns"
                name="columns"
                :value="col.key">
                {{ col.key }}
              </b-form-checkbox>
            </div>
          </b-dropdown>
        </list-control> -->
      </b-col>
    </b-row>

    <b-row>
      <b-table
        small
        striped
        hover
        head-variant="dark"
        :filter="search"
        @filtered="onFiltered"
        :items="values"
        :current-page="currentPage"
        :per-page="perPage"
        :fields="this.fields">
        <template v-slot:cell(#)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(value)="data">
          {{ valueLabel(data.value) }}
        </template>

        <template v-slot:cell(count)="data">
          {{ data.value | formatInt }}
        </template>
      </b-table>
    </b-row>

    <b-row v-if="totalRows" class="pt-2" @sort-changed="sortingChanged"
      style="vertical-align: top; border-top: 1px solid lightgrey;">
      <b-col :cols="12">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {titleCase} from '../Insights/utils';
  import InsightsComputationMixin from '../Insights/InsightsComputationMixin';
  import ListControl from '../Insights/ListControl';
  import {getCookie, setCookie} from '../../utils';
  import {maybeMissingValueLabel} from '../Insights/utils';

  export default {
    name: 'ListKeyInsight',

    components: {ListControl},

    props: {
      tableName: String,
      insightId: String,
      values: Array
    },

    watch: {
      values(v) {
        console.log(v);
      }
    },

    data() {
      const columns = Object.keys(this.values[0]);
      const fields = [];
      columns.forEach(column => {
          fields.push({key: column, sortable: true})
        });
      return {
        totalRows: this.values.length,
        columns: columns,
        valueLabel: maybeMissingValueLabel,
        enableSort: true,
        enableFilter: true,
        fields: fields,
        perPage: 10,
        currentPage: 1,
        rowCount: 0,

        search: '',
        sortBy: null,
        sortOrder: 0,
        rowsPerPage: 10,

        isLoadingPage: false,
        activeDataPage: 0,
        startPosition: 0,
        titleCase
      }
    },

    methods: {
      sortingChanged(e) {
        this.sortBy = e.sortBy;
        this.sortOrder = e.sortOrder;
      },

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        console.log('items', filteredItems)
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },

      handleApply() {
        console.log("Sort by: ", this.sortBy);
        console.log("Sort by: ", this.sortOrder);
        // this.compute(true);
      }
    },

    computed: {
      cookieKey() {
        return `_fake_mem_${this.insightId}_6`;
      },

      tableFields() {
        const colMap = {};
        this.columns.forEach(column => {
          colMap[column] = {key: column, label: column, sortable: false};
        });

        return this.columns.map(column => ({
          key: column,
          label: column,
          sortable: false,
        }));
      },

      sortByColumns() {
        return this.tableFields.map(
          ({key, label}) => ({value: key, text: label}));
      },

      rows() {
        return this.values.length;
      },

      style() {
        return {
          maxHeight: "100%",
          // height: "130%",
          overflowY: 'auto',
          borderRadius: 4
        };
      }
    }
  };
</script>

<style scoped>

</style>
